import { type Dispatch, createContext } from 'react'

import type { State, Action } from '../state'

export const cwqDialogContext = createContext<
  [State, Dispatch<Action>] | undefined
>(undefined)
